import React from "react";

import Logo from "../assets/logo1.png";
import { MailOutline, Message, MessageOutlined, NotificationsOutlined } from "@mui/icons-material";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo-section">
          <img
            src={Logo}  // Replace with your logo path
            alt="Logo"
            className="footer-logo"
          />
          <p className="footer-description">
            Take control of your contacts in one place. Efficiently manage and
            categorize them, make video and phone calls, share your screen with
            many audiences, and send text or email messages to groups or
            individuals.
          </p>
        </div>
        <div className="footer-links-section">
          <div className="footer-link-item">
            <span className="footer-icon"><MessageOutlined/></span>
            <span>
              +1 (877) 777-1053 <br />
              <small>MON–FRI 9AM–5PM PST</small>
            </span>
          </div>
          <div className="footer-link-item">
            <span className="footer-icon"><MailOutline/></span>
            <span>info@synkoria.com</span>
          </div>
          <div className="footer-link-item">
            <span className="footer-icon"><NotificationsOutlined/></span>
            <span>sign up now</span>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          ©{new Date().getFullYear()} All Rights Reserved. Powered by <strong>SYNKORIA.com</strong>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
